module.exports = __webpack_public_path__ + "img/icon_benefit-rest-refocus.e111f28f.svg";